var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarBadge = function SvgStarBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 12 13"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#star-badge_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D09C16",
    fillRule: "evenodd",
    d: "m2.59 6.967-.39-.322-.253.438-1.89 3.273a.428.428 0 0 0 .482.627l1.628-.435.436 1.627a.428.428 0 0 0 .785.103l1.64-2.838.18-.315-.28-.231zm6.82 0 .39-.322.254.438 1.889 3.273a.428.428 0 0 1-.483.627l-1.627-.435-.436 1.627a.428.428 0 0 1-.785.103L6.973 9.44l-.182-.315.28-.231z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD334",
    fillRule: "evenodd",
    d: "M5.997.508a4.393 4.393 0 1 0 0 8.786 4.393 4.393 0 0 0 0-8.786",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D09C16",
    d: "m6.172 2.586.586 1.177a.18.18 0 0 0 .149.109l1.3.197a.197.197 0 0 1 .108.34l-.96.912a.19.19 0 0 0 0 .177L7.54 6.79a.197.197 0 0 1-.291.21L6.09 6.39a.23.23 0 0 0-.191 0l-1.158.613a.197.197 0 0 1-.291-.21l.217-1.294a.19.19 0 0 0-.034-.177l-.959-.919a.197.197 0 0 1 .11-.333l1.3-.19a.18.18 0 0 0 .149-.11l.585-1.177a.197.197 0 0 1 .354-.006"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "star-badge_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h12v12H0z"
  })))));
};
export default SvgStarBadge;